import Vue from 'vue'

const app = {
  state: {
    darkMode: true,
    locale: 'en',
    // error: null
  },

  mutations: {
    SET_DARK_MODE: (state, darkMode) => {
      state.darkMode = darkMode
    },
    SET_LOCALE: (state, locale) => {
      state.locale = locale
    },
    // SET_NAME: (state, { name, welcome }) => {
    //   state.name = name
    //   state.welcome = welcome
    // },
    // SET_AVATAR: (state, avatar) => {
    //   state.avatar = avatar
    // },
    // SET_INFO: (state, info) => {
    //   state.info = info
    // },
    // SET_ERROR: (state, error) => {
    //   state.error = error
    // }
  },

  actions: {
    // User info
    SetDarkMode ({ commit }, on) {
      Vue.ls.set('DARK_MODE', on)
      commit('SET_DARK_MODE', on)
    },
    SetLocale ({ commit }, locale) {
      Vue.ls.set('LOCALE', locale)
      commit('SET_LOCALE', locale)
    }
  }
}

export default app
